export const zzconfig = {
    PHONE: "0595-87777157",
};
